import urljoin from 'url-join';
import { useHistory } from 'react-router';

import { useCapacitor } from 'Util/Capacitors';
import fetch2, { METHOD } from 'Util/fetch';
import { genUserEvent, USER_ACTIONS } from 'Util/Analytics';
import useTracking from 'Util/Analytics/useTracking';

const { useConfig } = require('Context/ConfigContext');

const useQuickAccess = (quickAccessItems = []) => {
  const { userApi } = useConfig();
  const { openUrl } = useCapacitor();
  const { logAction } = useTracking();
  const history = useHistory();

  let quickAccessList = [];

  quickAccessList = quickAccessItems.map((quickAccessItem) => {
    const { link, GALabel } = quickAccessItem;

    let fullURL = link;
    const hasTokenWithLink = !!fullURL.match('{token}');
    const hasMygoalWithLink = !!fullURL.match('/mygoal');

    return {
      ...quickAccessItem,
      onClick: async () => {
        if (hasTokenWithLink) {
          const token = await fetch2(urljoin(userApi, '/me/session'), {}, METHOD.POST, null, {
            isRedirect: false,
            includeCredentials: true,
          });
          fullURL = token ? link.replace('{token}', token) : link;
        }
        logAction(genUserEvent(USER_ACTIONS.QUICK_ACCESS, GALabel));

        if (hasMygoalWithLink) {
          history.push(fullURL);
        } else {
          openUrl(fullURL, () => window.open(fullURL, '_blank'));
        }
      },
    };
  });
  return quickAccessList;
};

export default useQuickAccess;
